module.exports = __webpack_public_path__ + "static/img/5.eac4eec.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/image/05/1/5.png
// module id = 06dU
// module chunks = 2